import React, { useMemo } from 'react';
import { ButtonAppearance } from '@harmony/enablers/components/button/button';
import { Button } from '../providers/harmony-scope/lazy-enablers';

interface IProps {
  children: React.ReactNode;
  contentNumber?: number;
  color?: string;
  variation?: 'content' | 'dot';
  hide?: boolean;
}

const useGetCountStyle = (color: string, variation: string) =>
  useMemo(() => {
    const countStyle: React.CSSProperties = {
      position: 'absolute',
      top: 1,
      right: 3,
      backgroundColor: color,
      borderRadius: '50%',
      width: variation === 'dot' ? '8px' : '14px',
      height: variation === 'dot' ? '8px' : '14px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'white',
      fontSize: '.6rem',
      textAlign: 'center',
      verticalAlign: 'middle',
      lineHeight: variation === 'dot' ? '8px' : '14px',
    };
    return countStyle;
  }, [color, variation]);

const BadgeWithCount = (props: IProps) => {
  const { children, contentNumber, color = 'var(--he-accent-fill-rest)', variation = 'content', hide = false } = props;
  const countStyle = useGetCountStyle(color, variation);

  return (
    <span>
      {children}
      {!hide && <div style={countStyle}>{variation === 'content' && contentNumber !== undefined ? `${contentNumber}` : ' '}</div>}
    </span>
  );
};

interface IButtonProps extends IProps {
  onClick?: () => void;
  appearance?: ButtonAppearance;
  id?: string;
}

export const ButtonWithBadgeWithCount = (props: IButtonProps) => {
  const {
    children,
    contentNumber,
    color = 'var(--he-accent-fill-rest)',
    variation = 'content',
    hide = false,
    onClick = () => {},
    id = 'OpenNotificationsPanel',
    appearance = 'command',
  } = props;
  const countStyle = useGetCountStyle(color, variation);

  return (
    <Button id={id} appearance={appearance} onClick={onClick}>
      {children}
      {!hide && <div style={countStyle}>{variation === 'content' && contentNumber !== undefined ? `${contentNumber}` : ' '}</div>}
    </Button>
  );
};

export default BadgeWithCount;
